import copy from "copy-to-clipboard";
import axios from 'axios';
import { useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Box, Typography, LinearProgress, Alert, Snackbar, Button, useTheme } from "@mui/material";
import moment from "moment";
import 'moment-timezone';

import HomeIcon from '@mui/icons-material/Home';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import IosShareIcon from '@mui/icons-material/IosShare';
import { ShareIcon } from "../../Icons";
import Logo from '../../assets/image/Logo.png';
import KedyAILogo from "../../assets/image/home/kedy-mini.svg"

import './assetView.scss';
import { GetShareLink } from "../../axios/ApiProvider";
import PricingModal from "../Pricing/pricingModal";

const HOME_FRONTEND_URL = process.env.REACT_APP_BASE_FRONTEND_URL

export const ShareView = () => {
  const languageStrs = useSelector((store) => store.editdata.languageStrs)
  let history = useNavigate();
  let { uuid } = useParams();
  const [openHelper, setOpenHelper] = useState(false);
  const [progressVal, setProgressVal] = useState(0);
  const [videoDownloading, setVideoDownloading] = useState(false);
  const [userData, setUserData] = useState({})
  const loginState = useSelector((store) => store.maindata.loginState)
  const [showPricingPageModal, setShowPricingPageModal] = useState(false)
  const [assetsData, setAssetsData] = useState(null);
  const [videoBlob, setVideBlob] = useState();

  useEffect(() => {
    let tempData = {}
    let item = localStorage.getItem('user_data')
    if (!!item && JSON.parse(item)?.state === 'loggedin') tempData = JSON.parse(item)

    setUserData(tempData)
  }, [loginState])

  useEffect(() => {
    const fetchShareLink = async () => {
      try {
        const fetchShareLink = await GetShareLink(uuid);
        if(fetchShareLink.state == "success") {
          setAssetsData({
            filename: fetchShareLink.data.asset_title,
            signedurl: fetchShareLink.data.asset_link,
            title: fetchShareLink.data.asset_title,
            category: 5,
            uuid: fetchShareLink.data.uuid,
            asset_owner: fetchShareLink.data.asset_owner
          })
        }
      } catch (error) {
        
      }
    }
    fetchShareLink();
  }, [uuid]);

  const downloadFunc = () => {
    if(assetsData && assetsData.signedurl) {
      let videoUrl = assetsData?.signedurl;
      const filename = assetsData?.filename || "Unknown_File_Name.mp4"
      if (!videoUrl) return;
      if(videoBlob){
        const aElement = document.createElement('a');
        aElement.setAttribute('download', filename);
        const href = URL.createObjectURL(videoBlob);
        aElement.href = href;
        aElement.setAttribute('target', '_blank');
        aElement.click();
        URL.revokeObjectURL(href);
        setVideoDownloading(false);
      }else{
        setProgressVal(0);
        axios.get(videoUrl, 
          {responseType: 'blob',
            onDownloadProgress: progressEvent => {
              setVideoDownloading(true);
              setProgressVal(Math.floor(progressEvent.progress * 100));
            }
          }).then(res=>{
            setVideBlob(res.data);
            const aElement = document.createElement('a');
            aElement.setAttribute('download', filename);
            const href = URL.createObjectURL(res.data);
            aElement.href = href;
            aElement.setAttribute('target', '_blank');
            aElement.click();
            URL.revokeObjectURL(href);
            setVideoDownloading(false);
        })
      }

    } else {
      window.toastr.error("Can not download") 
    }
  }

  const removeVideoExtension = (filename) => {
    if (!filename) return filename;
    return filename.replace(/\.(mp4|mov|avi|mkv|webm|flv|wmv)$/i, "");
  }

  let project_url = window.location.href;
  const [opanAlert, setOpenAlert] = useState(false);
  const copyLinkFunc = () => {
    let copy_res = copy(project_url);
    if (!copy_res || opanAlert) return;

    setOpenAlert(true);
    setTimeout(() => { setOpenAlert(false); }, 1500);
  }

  const [leftTime, setLeftTime] = useState(0);

  let [showTime, setShowTime] = useState([1970, 0, 1, 0, 0, 0])
  const [time_, setTime_] = useState(+new Date());
  useEffect(() => {
    const currentT = new Date();
    let handler = setTimeout(async () => {
      setTime_(currentT.getTime());
      let passTime = + new Date() - currentT.getTime();

      let newLeftTime = leftTime - passTime;
      if (newLeftTime > 0) setShowTime(moment(new Date(newLeftTime).toGMTString())._a)
      else setShowTime([1970, 0, 1, 0, 0, 0]);
      if (leftTime > 0) setLeftTime(newLeftTime);
    }, 1000)
    return () => handler && clearTimeout(handler);
  }, [time_]);

  let floorHour = showTime[4] > 0 ? 1 : showTime[5] > 0 ? 1 : 0;
  let leftHours = (showTime[2] - 1) * 24 + showTime[3] + floorHour;

  const getDate = () => {
    let date = new Date();
    const day = date.getDate();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const str = `${day}/${month}/${year}`;

    return str;
  }

  const handleClosePricingModal = () => {
    setShowPricingPageModal(false)
  }

  return (
    <>
      <Box className="project-view-wrapper">
        <Box component='section' className="view-body-section">
          <Box className="header-section">
            <Box className="header-left">
              <Link to={!!loginState ? HOME_FRONTEND_URL + "/dashboard/voiceclones" : HOME_FRONTEND_URL} className="home-icons">
              <HomeIcon sx={{width: "36px !important", height: "36px !important", color: "#175CE5 !important"}}/>
                <Box component='span' />
                <Box
                  sx={{
                    "img": {
                      height: "36px !important",
                      objectFit: "contain"
                    }
                  }}
                >
                  <img src={Logo} alt='logo'/>
                </Box>
              </Link>

            </Box>
          </Box>

          {assetsData?.signedurl
            ?
            <Box 
              position={"relative"} 
              padding={"0 2rem"}
            >
              <video
                src={assetsData.signedurl}
                playsInline
                crossOrigin="anonymous"
                controls
                style={{ minHeight: "80vh", maxHeight: "80dvh", width: '100%' }}
              >
              </video>
            </Box>
            :
            <Box className="video-section">
              <Box className="video-container"></Box>
            </Box>}

          <Typography variant='h3' margin={"1rem 0 0 2rem"}>{removeVideoExtension(assetsData?.filename)}</Typography>
        
          {assetsData?.signedurl && (
            <Box className="footer-section">
              <Box className="footer-contain">
                {!!loginState && (
                  <Typography component='h2' sx={{ textTransform: 'uppercase' }}>
                    {(userData?.username || '').slice(0, 1)}
                  </Typography>
                )}

                <Box component='span'>
                  <Typography variant='body1'>{assetsData?.asset_owner || "Anonymous"}</Typography>
                  <Box className="content">
                    <Typography component='h5'><LanguageOutlinedIcon /> {languageStrs.unlisted_video}</Typography>
                    <Typography component='h6'>{getDate()}</Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
        </Box>

        <Box component='section' className="view-sidebar-section">
          <Box className="sidebar-header-contain">
            <Box className="header-background"/>
            <a href={HOME_FRONTEND_URL} target="_blank">
              <img src={KedyAILogo} className="m-auto my-50 w-full" alt="export logo" />
            </a>
            {/* <Typography varian='h5'>{languageStrs.your_video_about_ready}</Typography> */}
          </Box>

          <Box className="sidebar-button-group-new">
            {videoDownloading && (
              <Box component='button' style={{display: 'block'}} sx={{marginBottom: 2}}>
                <Box className="flex" style={{flexDirection: 'row-reverse', justifyContent: "space-between"}}>
                <Typography component='h2'>{progressVal}%</Typography>
                <Typography component='h2'>{languageStrs.downloading}... </Typography>
                </Box>
                
                <Box className="w-full">
                  <LinearProgress variant="determinate" value={progressVal} color={"success"} />
                </Box>
              </Box>
            )}
            {!videoDownloading && (
            <Button color="success" onClick={downloadFunc} variant="contained" endIcon={<FileDownloadOutlinedIcon />} sx={{marginBottom: 2}}>
              <Typography variant='h5'>{languageStrs.download}</Typography>
            </Button>)}

          </Box>

          <Button onClick={copyLinkFunc} variant="contained" endIcon={<IosShareIcon />} sx={{marginBottom: 2}}>
            <Typography variant='h5'>{languageStrs.share} link</Typography>
          </Button>

        </Box>

        <Snackbar
          open={opanAlert}
          onClose={() => { setOpenAlert(false); }}
          anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
        >
          <Alert variant="filled" severity="success" sx={{ width: '250px' }}>{languageStrs.link_copied}</Alert>
        </Snackbar>
      </Box >
      <PricingModal open={showPricingPageModal} onCloseModal={handleClosePricingModal} />
    </>
  )
}